<template>
  <div id="Bannerlist">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">通告詳情</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">通告動態</li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'AdminNotificationList' }">
                  通告列表
                </router-link>
              </li>
              <li class="breadcrumb-item active">通告詳情</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-8 col-sm-12">
            <div class="card card-secondary">
              <div class="card-body">
                <div class="row pt-3">
                  <div class="col-12">
                    <label for="b-event-title">通告標題</label>
                    <div class="form-group">
                      <el-input
                        v-model="info.sgL_Title"
                        placeholder="请输入内容"
                      ></el-input>
                    </div>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col-12">
                    <label for="b-event-category">*通告類型（可多選）</label>
                  </div>
                </div>
                <div class="form-group mb-3">
                  <div class="row">
                    <el-checkbox-group v-model="info.sgL_Type">
                      <el-checkbox label="Index">首頁</el-checkbox>
                      <el-checkbox label="Photo">相簿</el-checkbox>
                      <el-checkbox label="Activity">活動</el-checkbox>
                      <el-checkbox label="NewArticle">話題</el-checkbox>
                      <el-checkbox label="BLog">網誌</el-checkbox>
                      <el-checkbox label="Moive">影音</el-checkbox>
                      <el-checkbox label="Group">群組</el-checkbox>
                      <!-- <el-checkbox label="ALL">全部頁面</el-checkbox> -->
                    </el-checkbox-group>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col-lg-2 col-md-4">
                    <label for="b-event-status">*刊登狀態</label>
                  </div>
                  <div class="col-lg-5 col-md-5">
                    <label for="b-register-start-date">開始日期</label>
                  </div>
                  <div class="col-lg-5 col-md-5">
                    <label for="b-register-end-date">截止日期</label>
                  </div>
                </div>
                <div class="row">
                  <!-- radio -->
                  <div class="col-lg-2 col-md-3">
                    <div class="form-group">
                      <el-select v-model="info.sgL_Status" placeholder="請選擇">
                        <el-option label="緊急刊登" value="UrgentPublication">
                        </el-option>
                        <el-option label="刊登" value="Inpublish"> </el-option>
                        <el-option label="停止刊登" value="StopPublish">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-5">
                    <el-date-picker
                      v-model="info.sgL_StartTime"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </div>
                  <div class="col-lg-5 col-md-5">
                    <el-date-picker
                      v-model="info.sgL_EndTime"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col-12">
                    <div class="card-title">通告內容</div>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                    <!-- Text Area -->
                    <div class="form-group">
                      <Editor v-model="info.sgL_Content"></Editor>
                    </div>
                    <!-- /.text-area -->
                  </div>
                </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
        <div class="row justify-content-center">
          <div class="col-8">
            <a
              href="javascript:;"
              @click="
                $router.push({
                  name: 'AdminNotificationList',
                })
              "
              class="btn btn-secondary"
              >取消</a
            >
            <input
              type="submit"
              value="保存"
              class="btn btn-primary float-right"
              @click="save"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import Editor from "@/components/common/Editor";
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  components: {
    pagination,
    Editor,
  },
  data() {
    return {
      info: {
        id: undefined,
        sgL_Title: "",
        sgL_Type: [],
        sgL_Status: "Inpublish",
        sgL_Content: "",
        sgL_StartTime: "",
        sgL_EndTime: "",
      },
      loading: true,
    };
  },
  async created() {
    await this.getInfo();
  },
  watch: {
    selectValue: {
      handler(newvalue, oldvalue) {
        this.handleCurrentChange(1);
      },
    },
  },
  methods: {
    async getInfo() {
      if (this.$route.query && this.$route.query.id) {
        const res = await this.$api.BannerApi.AdminSystemNoticeGet({
          id: this.$route.query.id,
        });
        if (res.data.success) {
          const rst = res.data.result;
          rst.sgL_Type = rst.sgL_TypeF;
          rst.sgL_StartTime = rst.sgL_StartTimeF;
          rst.sgL_EndTime = rst.sgL_EndTimeF;
          delete rst.sgL_TypeF;
          delete rst.sgL_StartTimeF;
          delete rst.sgL_EndTimeF;
          Object.keys(this.info).forEach((c) => {
            this.info[c] = rst[c];
          });
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
      }
    },
    save() {
      if (!this.info.sgL_Title) {
        Message({
          type: "warning",
          message: "請輸入通告標題",
        });
        return;
      }
      if (!this.info.sgL_Content) {
        Message({
          type: "warning",
          message: "請輸入通告內容",
        });
        return;
      }
      if (!this.info.sgL_Type.length) {
        Message({
          type: "warning",
          message: "請選擇通告類型",
        });
        return;
      }
      if (!this.info.sgL_Type.length) {
        Message({
          type: "warning",
          message: "請選擇通告類型",
        });
        return;
      }
      if (!this.info.sgL_Status) {
        Message({
          type: "warning",
          message: "請選擇刊登狀態",
        });
        return;
      }
      if (!this.info.sgL_StartTime) {
        Message({
          type: "warning",
          message: "請選擇開始日期",
        });
        return;
      }
      if (!this.info.sgL_EndTime) {
        Message({
          type: "warning",
          message: "請選擇截止日期",
        });
        return;
      }
      let med = null;
      if (this.info.id) {
        med = this.$api.BannerApi.AdminSystemNoticeUpdate;
      } else {
        med = this.$api.BannerApi.AdminSystemNoticeCreate;
      }
      med(this.info).then((res) => {
        if (res.data.success) {
          Message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.$router.push({
            name: "AdminNotificationList",
          });
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}

/* .b-ad-name a {
  display: inline-block;
  position: relative;
}
.b-ad-name a img {
  display: none;
  position: absolute;
  z-index: 1100;
  min-height: 90px;
  max-height: 500px;
  top: 50%;
  left: calc(100% + 1rem);
  transform: translateY(-50%);
} */
</style>


// WEBPACK FOOTER //
// src/components/AdminNotification/detail.vue